import { Box, Grid2, List, ListItem, ListItemText, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { CiYoutube } from "react-icons/ci";
import { FaInstagram, FaFacebook } from "react-icons/fa";
import { Constants, Main_URL, Page_Padding, ProSkillUrl } from "../shared/constants";

import useResponsive from "../shared/utils/Responsive";
import CustomDivider from "../shared/utils/CustomDivider";
import { HashLink } from 'react-router-hash-link';
import { useGetFooterDetail } from "../assets/nodeApi/getApi/ContentGetApi";


const iconStyle = {
    fontSize: "20px",
    color: "#DC143C",
};


const FooterList = ({ title, items }) => (
    <Box>
        <Typography variant="body1" fontSize={"20px"} gutterBottom>
            {title}
        </Typography>
        <List sx={{ p: 0 }}>
            {items?.map((item, index) => (
                <>
                    {item?.isEnabled &&
                        <ListItem sx={{ py: 0.1, display: "flex", alignItems: "center", pl: "0" }} key={index}>
                            <Link
                                to={item?.url} style={{ textDecoration: "none", color: "inherit", display: "flex", alignItems: "center", gap: "10px" }}
                                target={item?.isExternal ? "_blank" : "_self"}
                                rel={item?.isExternal ? "noopener noreferrer" : ""}
                            >
                                {item?.icon && <Box sx={{ display: "flex", alignItems: "center" }}>{item?.icon}</Box>}
                                <ListItemText primary={<Typography variant="body2" color="grey.100">{item?.label}</Typography>} />
                            </Link>
                        </ListItem>

                    }
                </>
            ))}
        </List>
    </Box>
);

const Footer = () => {
    const { data: footerData, isLoading: isFooterDataLoading } = useGetFooterDetail()


    const isSmallScreen = useResponsive("md")
    // const QuickLinks = [
    //     // { name: "Home", path: "/" },
    //     // { name: "About Us", path: "/About" },
    //     { name: "Courses", path: "/Courses" },
    //     { name: "Skill2Skool", path: "/SkillToSchool" },
    //     { name: "Skillbox", path: "/SkillBox" },
    //     { name: "Skill4Teachers", path: "/SkillFourTeachers" },
    //     { name: "Events", path: "/Events" },
    //     // { name: "MySkill Pro", path: proSkillUrl },
    //     // { name: "On Boarding", path: "/Apartmentonboarding" },
    //     // { name: "Trainer Sign Up", path: "/TrainerSignUp" },
    //     // { name: "Apartment Sign Up", path: "/ApartmentSignUp" },
    //     // { name: "Apartment Login", path: "/ApartmentLogin" },

    //     // { name: "FAQ", path: "/Faq" },
    //     // { name: "Contact Us", path: "/ContactUs" },
    //     // { name: "Leader Board", path: "/CompetitionCourses" },
    //     // { name: "Polling", path: "/PollingOfCompetition" },
    //     // { name: "Polling Result", path: "/PollingResult" },
    //     // { name: "Leader Board", path: "/FinalPriceDestribution" },

    // ];


    const QuickLinks = [
        ...(footerData?.data?.sections[1]?.links || [])
    ];

    const ConnectInfo = [
        { name: "YouTube", icon: <CiYoutube style={iconStyle} />, path: "https://www.youtube.com/@Myskill_club" },
        { name: "Instagram", icon: <FaInstagram style={iconStyle} />, path: "https://www.instagram.com/myskoolclub_bangalore/?igsh=YzcwMzYzMXU3a3Ux&utm_source=qr#" },
        { name: "Facebook", icon: <FaFacebook style={iconStyle} />, path: "https://www.facebook.com/share/18wPR1Df5b/?mibextid=wwXIfr" },
    ];

    // const LegalList = [
    //     { name: "Privacy Policy", path: "/PrivacyPolicy" },
    //     { name: "Refund Policy", path: "/RefundPolicy" },
    //     { name: "Shipping Policy", path: "/ShippingPolicy" },
    //     { name: "Pricing Policy", path: "/PricingPolicy" },
    //     { name: "Terms & Conditions", path: "/TermAndCondition" },
    // ];

    const LegalList = footerData?.data?.sections[5]?.links


    // const JoinUs =
    //     [
    //         { name: "Partner with us", path: "/Apartmentonboarding" },
    //         { name: "Teach with us", path: ProSkillUrl, isExternal: true },
    //     ];

    const JoinUs = footerData?.data?.sections[2]?.links

    // const Community =
    //     [
    //         { name: "She Inspire", path: "/SheInspire" },
    //         { name: "Time", path: `${Main_URL}times/`, isExternal: true },
    //         { name: "Leader Board", path: "/CompetitionCourses" },



    //     ];

    const Community = footerData?.data?.sections[3]?.links

    // const Other =
    //     [
    //         { name: "Shop", path: `${Main_URL}shop/`, isExternal: true },
    //         { name: "FAQ", path: "/Faq" },
    //         { name: "Contact Us", path: "/ContactUs" },
    //     ];

    const Other = footerData?.data?.sections[4]?.links

    // const LeftLinks = [
    //     { name: "About Us", path: "/About" },
    //     { name: "The Vision", path: "/About", id: "vision" },
    //     { name: "The Team", path: "/About", id: "team" },
    // ];

    const LeftLinks = footerData?.data?.sections[0]?.links

    // const NewLink = [
    //     {

    //         "label": "ELYF",
    //         "url": "/EducationForLife",
    //         "isEnabled": true,

    //     },
    //     {

    //         "label": "Ai Edge",
    //         "url": "/AiEdge",
    //         "isEnabled": true,

    //     },
    //     {

    //         "label": "Summer Camp",
    //         "url": "/SummerCamp",
    //         "isEnabled": true,

    //     }
    // ]


    return (
        <Grid2 container component="footer" sx={{ pt: "45px", pb: { xs: "70px", sm: "45px" }, px: Page_Padding, bgcolor: "primary.light" }} spacing={5} >
            <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                <img src={Constants.customImages.Logo} width={"200px"} height={"auto"} />
                <List
                    sx={{
                        p: 0,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 2,
                    }}
                >
                    {LeftLinks?.map(({ label, url, id, isEnabled }, index) => {
                        // Build the link with hash if id exists
                        // const linkPath = id ? `${path}#${id}` : path;

                        return (
                            <>

                                {
                                    isEnabled && <ListItem
                                        key={index}
                                        sx={{
                                            py: 0.1,
                                            display: "flex",
                                            alignItems: "center",
                                            px: 1,
                                            width: "auto",
                                        }}
                                    >
                                        <HashLink
                                            smooth
                                            // to={`${path}${id ? `#${id}` : ''}`}
                                            to={url}
                                            style={{
                                                textDecoration: "none",
                                                color: "inherit",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "10px"
                                            }}
                                        >
                                            <ListItemText
                                                primary={
                                                    <Typography variant="body2" color="grey.100">
                                                        {label}
                                                    </Typography>
                                                }
                                            />
                                        </HashLink>
                                    </ListItem>
                                }
                            </>

                        );
                    })}
                </List>


                <Typography variant="body2" sx={{ color: "grey.100", lineHeight: "22px", mt: 2 }} dangerouslySetInnerHTML={{ __html: footerData?.data?.sections[0]?.description }} />
                {/* {footer?.data?.site_description} */}


            </Grid2>

            <Grid2 children size={{ xs: 12, sm: isSmallScreen ? 4 : 3 }}>
                <FooterList title="Quick Links" items={QuickLinks} />
                <CustomDivider size={"2rem"} />
                <FooterList title="Get Involved" items={JoinUs} />
            </Grid2>

            <Grid2 children size={{ xs: 12, sm: isSmallScreen ? 4 : 2.5 }}>
                {/* <FooterList title="Connect With Us" items={ConnectInfo} /> */}
                <FooterList title="Community" items={Community} />
                <CustomDivider size={"2rem"} />
                <FooterList title="Others" items={Other} />
                {/* <CustomDivider size={"2rem"} /> */}
                {/* <FooterList title="New Link" items={NewLink} /> */}

            </Grid2>

            <Grid2 children size={{ xs: 12, sm: isSmallScreen ? 4 : 2.5 }}>
                <FooterList title="Legal" items={LegalList} />
            </Grid2>
            <Grid2 children size={12}>
                <Typography variant="body2" color="text.secondary" textAlign={"center"}>{footerData?.data?.copyrightNotice}</Typography>
            </Grid2>
        </Grid2>
    );
};

export default Footer;
